import { id, resource } from "@planzone/dto";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import {
  handleEditRequest,
  handleEditSuccess,
  handleEditFailure,
} from "./editResource";
import {
  handleAssignTagFailure,
  handleAssignTagSuccess,
  handleAssignTagRequest,
} from "./assignTag";
import {
  handleRemoveTagFailure,
  handleRemoveTagSuccess,
  handleRemoveTagRequest,
} from "./removeTag";
import { handleChangeProfilePicture } from "./changeProfilePicture";
import { handleUpdateOrganizationalUnitSuccess } from "./updateOrganizationalUnit";
import { handleCreateOrganizationalUnitSuccess } from "./createOrganizationalUnit";
import { handleRemoveOrganizationalUnitSuccess } from "./removeOrganizationalUnit";
import {
  handleAssignCostProfileToResourceRequest,
  handleAssignCostProfileToResourceSuccess,
  handleAssignCostProfileToResourceFailure,
  handleRemoveCostProfileFromResourceRequest,
  handleRemoveCostProfileFromResourceSuccess,
  handleRemoveCostProfileFromResourceFailure,
} from "./assignCostProfile";
import {
  handleEditCostProfileRequest,
  handleEditCostProfileSuccess,
  handleEditCostProfileFailure,
} from "./editCostProfile";
import {
  handleValidateTimeRecordsUpToDateRequest,
  handleValidateTimeRecordsUpToDateSuccess,
  handleValidateTimeRecordsUpToDateFailure,
} from "./validatePersonalTimeRecordsUpToDate";

const initialState = { ...resource, uuid: id };

const reduceResource = createStateReducer(initialState, {
  [events.editResourceRequested]: handleEditRequest,
  [events.editResourceSucceeded]: handleEditSuccess,
  [events.editResourceFailed]: handleEditFailure,
  [events.assignTagRequested]: handleAssignTagRequest,
  [events.assignTagSucceeded]: handleAssignTagSuccess,
  [events.assignTagFailed]: handleAssignTagFailure,
  [events.removeTagRequested]: handleRemoveTagRequest,
  [events.removeTagSucceeded]: handleRemoveTagSuccess,
  [events.removeTagFailed]: handleRemoveTagFailure,
  [events.assignCostProfileToResourceRequested]:
    handleAssignCostProfileToResourceRequest,
  [events.assignCostProfileToResourceSucceeded]:
    handleAssignCostProfileToResourceSuccess,
  [events.assignCostProfileToResourceFailed]:
    handleAssignCostProfileToResourceFailure,
  [events.removeCostProfileFromResourceRequested]:
    handleRemoveCostProfileFromResourceRequest,
  [events.removeCostProfileFromResourceSucceeded]:
    handleRemoveCostProfileFromResourceSuccess,
  [events.removeCostProfileFromResourceFailed]:
    handleRemoveCostProfileFromResourceFailure,
  [events.editCostProfileRequested]: handleEditCostProfileRequest,
  [events.editCostProfileSucceeded]: handleEditCostProfileSuccess,
  [events.editCostProfileFailed]: handleEditCostProfileFailure,
  [events.validatePersonalTimeRecordsUpToDateRequested]:
    handleValidateTimeRecordsUpToDateRequest,
  [events.validatePersonalTimeRecordsUpToDateSucceeded]:
    handleValidateTimeRecordsUpToDateSuccess,
  [events.validatePersonalTimeRecordsUpToDateFailed]:
    handleValidateTimeRecordsUpToDateFailure,
  [events.changeProfilePictureSucceeded]: handleChangeProfilePicture,
  [events.updateOrganizationalUnitSucceeded]:
    handleUpdateOrganizationalUnitSuccess,
  [events.createOrganizationalUnitSucceeded]:
    handleCreateOrganizationalUnitSuccess,
  [events.removeOrganizationalUnitSucceeded]:
    handleRemoveOrganizationalUnitSuccess,
});

export { reduceResource };
